import React from 'react'
import { ResponseModel } from '../models/shared/ResponseModel';
import { Text } from '@wix/design-system';
import { round } from '../utils/logic';

interface Props {
    response: ResponseModel;
}

const EMOJIS = [
    { image: 'https://wix-customer-feedback.web.app/widget/smiley_best.png', value: 10 },
    { image: 'https://wix-customer-feedback.web.app/widget/smiley_better.png', value: 7.5 },
    { image: 'https://wix-customer-feedback.web.app/widget/smiley_neutral.png', value: 5 },
    { image: 'https://wix-customer-feedback.web.app/widget/smiley_worse.png', value: 2.5 },
    { image: 'https://wix-customer-feedback.web.app/widget/smiley_worst.png', value: 0 },
];

function NPSDisplay(props: Props) {
    const nps = props.response.nps;

    let emoji = EMOJIS[0];
    for (const e of EMOJIS) {
        if (Math.abs(e.value - nps) < Math.abs(emoji.value - nps)) {
            emoji = e;
        }
    }
    return <div className='d-flex align-items-center'>
        <img src={emoji?.image} className='nps-emoji me-2' alt='nps emoji' />
        <Text>{round(nps)}</Text>
    </div>
}

export default NPSDisplay
